module.exports = __webpack_public_path__ + "img/mean.d6890901.svg";